<template>
  <v-dialog v-model="showCustomerSupportDialog" persistent  :width="313">
    <v-card>
      <div class="support-modal">
        <div class="support-header">
          <div class="header-title">Customer Support</div>
          <div>
            <v-icon @click="close()">close</v-icon>
          </div>
        </div>
        <div class="support-description">Contact us during business hours: 8am - 5pm</div>
        <div class="contact-list">
          <div class="contact-item">
            <div class="contact-icon">
              <img src="@/assets/images/phone_icon.svg" alt="Call Us" />
            </div>
            <div class="contact-content">
              <div class="contact-title">Call Us</div>
              <div class="contact-source">
                <a href="tel:+1-877-483-3748">877-483-3748</a>
              </div>
            </div>
          </div>
          <div class="contact-item">
            <div class="contact-icon">
              <img src="@/assets/images/email_icon.svg" alt="Email Us" />
            </div>
            <div class="contact-content">
              <div class="contact-title">Email Us</div>
              <div class="contact-source">
                <a href="mailto:support@itovi.com" target="_blank" rel="noopener noreferrer">
                  support@itovi.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>


<script>
  import store from "@/store";
  import subscribeToStore from "@/mixins/subscribeToStore";

  export default {
    data: () => ({
      showCustomerSupportDialog: store.state.showCustomerSupportDialog
    }),
    mixins: [subscribeToStore],
    mounted() {
      this.subscribeToStore(['showCustomerSupportDialog']);
    },
    methods: {
      close() {
        store.commit('setShowCustomerSupportDialog', false);
      }
    }
  }

</script>
